module.exports = "/assets/src/client/assets/topLevelPage/styled-Next.svg";